/* ══════════════════════════════════════════════════════════════
   Live TV — Indian Financial TV Embeds
   CNBC-TV18, NDTV Profit, ET NOW, Zee Business
   ══════════════════════════════════════════════════════════════ */

export interface LiveChannel {
    name: string;
    youtubeId: string;
    icon: string;
    language: string;
}

const CHANNELS: LiveChannel[] = [
    { name: 'CNBC-TV18', youtubeId: 'UCmRbJMBEByljnOFn3BO0byQ', icon: '📺', language: 'English' },
    { name: 'NDTV Profit', youtubeId: 'UCkknBMbhB0udIhP3t5HKGMA', icon: '📺', language: 'English' },
    { name: 'ET NOW', youtubeId: 'UCWmq-130vBnMnALDABrwNNg', icon: '📺', language: 'English' },
    { name: 'Zee Business', youtubeId: 'UCMFmyJchVj_iKSsVSwOplsA', icon: '📺', language: 'Hindi' },
    { name: 'CNBC Awaaz', youtubeId: 'UCmq2YDgR7WQTbkFashIBYUQ', icon: '📺', language: 'Hindi' },
    { name: 'Moneycontrol', youtubeId: 'UCAuUUnT6oDeKwE6v1NGQxug', icon: '📺', language: 'English' },
];

export function renderLiveTV(container: HTMLElement, activeChannel?: number): void {
    const active = activeChannel ?? 0;
    const channel = CHANNELS[active];

    const channelTabs = CHANNELS.map((ch, i) => `
    <button class="tv-channel-tab ${i === active ? 'active' : ''}" data-channel="${i}">
      ${ch.icon} ${ch.name}
      <span class="tv-lang">${ch.language}</span>
    </button>`).join('');

    container.innerHTML = `
    <div class="glass-card live-tv-panel">
      <div class="card-header">
        <h3>📺 Live TV</h3>
        <span class="live-badge">🔴 LIVE</span>
      </div>
      <div class="tv-channels-bar">
        ${channelTabs}
      </div>
      <div class="tv-embed-container">
        <iframe
          src="https://www.youtube.com/embed/live_stream?channel=${channel.youtubeId}&autoplay=0"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope"
          allowfullscreen
          loading="lazy"
          title="${channel.name} Live"
        ></iframe>
      </div>
      <div class="tv-footer">
        <small>Streams provided by YouTube. Market hours: 9:15 AM - 3:30 PM IST</small>
      </div>
    </div>`;

    // Add channel switching
    container.querySelectorAll('.tv-channel-tab').forEach(btn => {
        btn.addEventListener('click', () => {
            const idx = parseInt((btn as HTMLElement).dataset.channel || '0');
            renderLiveTV(container, idx);
        });
    });
}
